import React from "react"

const Button = () => {
    return (
        <button className="button"><a href="#home">explore</a></button>
    )
}

export default Button;